/* A&B Label theme — small, dependency-free */
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const S = window.AB || { strings: {}, routes: {} };

  const money = (cents) => {
    const fmt = S.moneyFormat || '{{amount}}';
    const v = (cents / 100);
    const two = v.toFixed(2), noDec = Math.round(v).toString();
    const withCommas = (n) => n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return withCommas(noDec);
      if (k === 'amount_with_comma_separator') return two.replace('.', ',');
      return withCommas(two);
    });
  };

  const toast = (msg) => {
    const t = $('#toast'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toast._t); toast._t = setTimeout(() => (t.hidden = true), 2600);
  };

  /* ---------- Drawers ---------- */
  let lastFocus = null;
  const openDrawer = (id) => {
    const d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    setTimeout(() => ($('[data-close].icon-btn', d) || d).focus(), 50);
  };
  const closeDrawers = () => {
    $$('.drawer.is-open').forEach((d) => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    document.body.classList.remove('no-scroll');
    if (lastFocus) lastFocus.focus();
  };
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); openDrawer(o.dataset.open); return; }
    if (e.target.closest('[data-close]')) { e.preventDefault(); closeDrawers(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawers(); closeSearch(); } });

  /* ---------- Desktop dropdown menus (hover + click + keyboard) ---------- */
  const navItems = $$('[data-nav-item]');
  const closeMenus = (except) => navItems.forEach((it) => { if (it === except) return; const b = $('.nav-toggle', it); b.setAttribute('aria-expanded', 'false'); $('.mega', it).hidden = true; });
  navItems.forEach((it) => {
    const btn = $('.nav-toggle', it), panel = $('.mega', it);
    const open = () => { closeMenus(it); btn.setAttribute('aria-expanded', 'true'); panel.hidden = false; };
    const shut = () => { btn.setAttribute('aria-expanded', 'false'); panel.hidden = true; };
    let t;
    btn.addEventListener('click', (e) => { e.preventDefault(); btn.getAttribute('aria-expanded') === 'true' ? shut() : open(); });
    if (matchMedia('(hover: hover)').matches) {
      it.addEventListener('mouseenter', () => { clearTimeout(t); open(); });
      it.addEventListener('mouseleave', () => { t = setTimeout(shut, 180); });
    }
    it.addEventListener('focusout', (e) => { if (!it.contains(e.relatedTarget)) shut(); });
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeMenus(); });
  document.addEventListener('click', (e) => { if (!e.target.closest('[data-nav-item]')) closeMenus(); });

  /* ---------- Search ---------- */
  const search = $('[data-search]');
  const closeSearch = () => search && (search.hidden = true);
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-search]')) { search.hidden = false; $('input[type=search]', search).focus(); }
    if (e.target.closest('[data-close-search]')) closeSearch();
  });

  /* ---------- Header state + announcement rotation ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }
  const rot = $('[data-rotate].is-rotating');
  if (rot) {
    const items = $$('.announce__item', rot); let i = 0;
    setInterval(() => { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }, 4000);
  }

  /* ---------- Reveal ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((ents) => ents.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px' });
    const watch = (root = document) => $$('.reveal:not(.is-in)', root).forEach((el) => io.observe(el));
    watch(); window.ABwatch = watch;
    // Only hide content once the observer is running, so nothing stays invisible if scripts are slow or blocked
    document.documentElement.classList.add('reveal-ready');
    // Safety net: anything already on screen after 3s is shown regardless
    setTimeout(() => $$('.reveal:not(.is-in)').forEach((el) => { const r = el.getBoundingClientRect(); if (r.top < innerHeight && r.bottom > 0) el.classList.add('is-in'); }), 3000);
  } else { $$('.reveal').forEach((el) => el.classList.add('is-in')); }

  /* ---------- Cart ---------- */
  const refreshCart = async (open = true) => {
    const r = await fetch(`${S.routes.root}?sections=cart-drawer`.replace('//?', '/?'));
    const data = await r.json();
    const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
    const fresh = $('[data-cart-drawer]', html), cur = $('[data-cart-drawer]');
    if (fresh && cur) {
      const wasOpen = cur.classList.contains('is-open');
      cur.innerHTML = fresh.innerHTML;
      document.dispatchEvent(new CustomEvent('ab:cart-updated'));
      if (wasOpen || open) { cur.classList.add('is-open'); cur.setAttribute('aria-hidden', 'false'); document.body.classList.add('no-scroll'); }
    }
    const c = await (await fetch(`${S.routes.cart}.js`)).json();
    $$('[data-cart-count]').forEach((el) => { el.textContent = c.item_count; el.hidden = c.item_count === 0; });
    return c;
  };

  const addToCart = async (formData) => {
    const r = await fetch(`${S.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
    const j = await r.json();
    if (!r.ok) throw new Error(j.description || j.message || S.strings.error);
    return j;
  };
  window.ABcart = { refresh: (o) => refreshCart(o), add: (fd) => addToCart(fd), money, toast };

  /* ---------- Remove a whole built set from the cart ---------- */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-set-remove]'); if (!b) return;
    e.preventDefault();
    const drawer = $('[data-cart-drawer]'); drawer?.classList.add('is-busy');
    try {
      const c = await (await fetch(`${S.routes.cart}.js`)).json();
      const updates = {};
      c.items.forEach((it) => { if (it.properties && it.properties._set === b.dataset.setRemove) updates[it.key] = 0; });
      const r = await fetch(`${S.routes.cart}/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
      if (!r.ok) throw new Error(S.strings.error);
      if (document.body.classList.contains('template-cart')) { location.reload(); return; }
      await refreshCart(false);
    } catch (err) { toast(err.message); }
    finally { drawer?.classList.remove('is-busy'); }
  });

  document.addEventListener('submit', async (e) => {
    const f = e.target;
    if (!f.matches('[data-product-form], [data-quick-add]')) return;
    e.preventDefault();
    const buyNow = e.submitter && e.submitter.hasAttribute('data-buy-now');
    const btn = buyNow ? e.submitter : $('button[type=submit]', f);
    if (btn?.disabled) return;
    btn?.classList.add('is-loading');
    try {
      const fd = new FormData(f); fd.delete('return_to');
      await addToCart(fd);
      if (buyNow) { location.href = btn.value || '/checkout'; return; }
      lastFocus = btn;
      await refreshCart(true);
      $('#cart-drawer [data-close].icon-btn')?.focus();
    } catch (err) { toast(err.message); }
    finally { btn?.classList.remove('is-loading'); }
  });

  const changeLine = async (key, qty) => {
    const drawer = $('[data-cart-drawer]');
    drawer?.classList.add('is-busy');
    try {
      const r = await fetch(`${S.routes.cartChange}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) });
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || S.strings.error);
      if (document.body.classList.contains('template-cart')) { location.reload(); return; }
      await refreshCart(false);
    } catch (err) { toast(err.message); }
    finally { drawer?.classList.remove('is-busy'); }
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-line-key]');
    if (b) { e.preventDefault(); changeLine(b.dataset.lineKey, parseInt(b.dataset.qty, 10)); }
  });
  document.addEventListener('change', (e) => {
    const i = e.target.closest('[data-line-input]');
    if (i) changeLine(i.dataset.lineInput, Math.max(0, parseInt(i.value, 10) || 0));
  });
  // Header cart icon: open drawer instead of navigating (link still works without JS)
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[data-open="cart-drawer"]');
    if (a && !document.body.classList.contains('template-cart')) { e.preventDefault(); openDrawer('cart-drawer'); }
  }, true);

  /* ---------- Change colour inside the cart ---------- */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-swap-key]'); if (!b) return;
    e.preventDefault();
    const drawer = $('[data-cart-drawer]'); drawer?.classList.add('is-busy');
    try {
      const fd = new FormData(); fd.append('id', b.dataset.swapTo); fd.append('quantity', b.dataset.swapQty); if (b.dataset.swapSet) { fd.append('properties[_set]', b.dataset.swapSet); fd.append('properties[_set_name]', b.dataset.swapSetName || ''); }
      await addToCart(fd);
      const r = await fetch(`${S.routes.cartChange}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: b.dataset.swapKey, quantity: 0 }) });
      if (!r.ok) throw new Error(S.strings.error);
      if (document.body.classList.contains('template-cart')) { location.reload(); return; }
      await refreshCart(false);
    } catch (err) { toast(err.message); }
    finally { drawer?.classList.remove('is-busy'); }
  });

  /* ---------- Change size inside the cart ---------- */
  document.addEventListener('change', async (e) => {
    const sel = e.target.closest('[data-swap-select]'); if (!sel || !sel.value) return;
    const drawer = $('[data-cart-drawer]'); drawer?.classList.add('is-busy');
    try {
      const fd = new FormData(); fd.append('id', sel.value); fd.append('quantity', sel.dataset.swapQty); if (sel.dataset.swapSet) { fd.append('properties[_set]', sel.dataset.swapSet); fd.append('properties[_set_name]', sel.dataset.swapSetName || ''); }
      await addToCart(fd);
      const r = await fetch(`${S.routes.cartChange}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: sel.dataset.swapKey, quantity: 0 }) });
      if (!r.ok) throw new Error(S.strings.error);
      if (document.body.classList.contains('template-cart')) { location.reload(); return; }
      await refreshCart(false);
    } catch (err) { toast(err.message); }
    finally { drawer?.classList.remove('is-busy'); }
  });

  /* ---------- Side-cart sets: pick sizes + add ---------- */
  const soldOut = (S.strings && S.strings.soldOut) || (document.documentElement.lang.startsWith('ar') ? 'نفد' : 'Sold out');
  const setupCartSet = (card) => {
    if (card._ready) return; card._ready = true;
    let vars = []; try { vars = JSON.parse($('[data-set-variants]', card).textContent); } catch (_) {}
    const sels = $$('[data-set-opt]', card), btn = $('[data-set-add]', card);
    const pick = () => sels.map((s) => s.value);
    const find = (o) => vars.find((v) => v.o.every((x, i) => x === o[i]));
    const paint = () => {
      const cur = pick();
      sels.forEach((s, i) => [...s.options].forEach((op) => {
        const o = cur.slice(); o[i] = op.value;
        const ok = vars.some((v) => v.a && v.o.every((x, k) => x === o[k]));
        op.textContent = op.dataset.label + (ok ? '' : ` – ${soldOut}`);
      }));
      const v = find(cur);
      btn.disabled = !(v && v.a); if (v) btn.dataset.variant = v.id;
      if (v && v.img) { const im = $('.cart-sets__media img', card); if (im && !im.src.includes(v.img.split('?')[0])) { im.removeAttribute('srcset'); im.src = v.img; } }
      const pr = $('[data-set-price]', card); if (v && pr && v.p != null) pr.textContent = money(v.p);
    };
    // Start from the shopper's size where possible, otherwise the first in-stock combo
    const pref = card.dataset.pref;
    sels.forEach((s) => { if (pref && [...s.options].some((o) => o.value === pref)) s.value = pref; });
    if (sels.length) {
      let v = find(pick());
      if (!(v && v.a)) {
        const fit = vars.filter((x) => x.a).sort((a, b) => b.o.filter((x) => x === pref).length - a.o.filter((x) => x === pref).length)[0];
        if (fit) sels.forEach((s, i) => { s.value = fit.o[i]; });
      }
    }
    sels.forEach((s) => s.addEventListener('change', paint));
    paint();
  };
  const initCartSets = () => $$('[data-cart-set]').forEach(setupCartSet);
  initCartSets();
  document.addEventListener('ab:cart-updated', initCartSets);
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-set-add]'); if (!b || b.disabled) return;
    e.preventDefault(); b.classList.add('is-loading');
    try {
      const fd = new FormData(); fd.append('id', b.dataset.variant); fd.append('quantity', 1);
      await addToCart(fd);
      await refreshCart(false);
    } catch (err) { toast(err.message); }
    finally { b.classList.remove('is-loading'); }
  });

  /* ---------- Size tables: cm ⇄ inches (tables are stored in cm, the factory unit) ---------- */
  const toIn = [['سنتيمتر', 'إنش'], ['centimetres', 'inches'], ['cm', 'inches']];
  const setUnit = (unit) => {
    $$('[data-size-table] tbody td').forEach((td) => {
      if (!td.previousElementSibling) return; // first column is the size name
      if (td.dataset.src === undefined) td.dataset.src = td.textContent;
      td.textContent = unit === 'in' ? td.dataset.src.replace(/\d+(?:\.\d+)?/g, (n) => String(Math.round(parseFloat(n) / 2.54 * 2) / 2)) : td.dataset.src;
    });
    $$('[data-unit-label]').forEach((el) => {
      if (el.dataset.src === undefined) el.dataset.src = el.textContent;
      let t = el.dataset.src;
      if (unit === 'in') toIn.forEach(([a, b]) => { t = t.split(a).join(b); });
      el.textContent = t;
    });
    $$('[data-unit-toggle] [data-unit]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.unit === unit)));
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-unit-toggle] [data-unit]'); if (!b) return;
    setUnit(b.dataset.unit);
    try { localStorage.setItem('ab-size-unit', b.dataset.unit); } catch (_) {}
  });
  try { if (localStorage.getItem('ab-size-unit') === 'in') setUnit('in'); } catch (_) {}

  /* ---------- Build your set: rotate colour photos so shoppers see they can mix colours ---------- */
  const calm = false;
  const startRotator = (box) => {
    if (box._rot) return; box._rot = true;
    const slides = $$('.sb-card__slide', box); if (slides.length < 2) return;
    let i = Math.floor(Math.random() * slides.length), visible = false;
    slides.forEach((s, k) => s.classList.toggle('is-on', k === i));
    // load the other photos now so the fade never shows a blank
    slides.forEach((s) => { const im = $('img', s); if (im) im.loading = 'eager'; });
    const tick = () => {
      if (visible && !document.hidden) {
        let n = Math.floor(Math.random() * (slides.length - 1)); if (n >= i) n += 1; // random, never the same twice
        slides[i].classList.remove('is-on'); slides[n].classList.add('is-on'); i = n;
      }
      setTimeout(tick, 2200 + Math.random() * 1400);
    };
    if ('IntersectionObserver' in window) new IntersectionObserver((es) => es.forEach((e) => { visible = e.isIntersecting; })).observe(box);
    else visible = true;
    setTimeout(tick, 900 + Math.random() * 900);
  };
  const initRotators = () => $$('[data-rotate]').forEach(startRotator);
  initRotators(); window.ABrotators = initRotators;

  /* ---------- Product card galleries ---------- */
  const isRtl = document.documentElement.dir === 'rtl';
  const cardIndex = (track) => Math.round(Math.abs(track.scrollLeft) / (track.clientWidth || 1));
  const setupCard = (media) => {
    const track = $('[data-card-track]', media); if (!track) return;
    const dots = $('[data-card-dots]', media);
    const slides = () => $$('.card__slide', track);
    const paint = () => {
      const n = slides().length, i = cardIndex(track);
      media.classList.toggle('has-many', n > 1);
      if (dots) {
        if (dots.childElementCount !== n) dots.innerHTML = n > 1 ? '<span></span>'.repeat(n) : '';
        [...dots.children].forEach((d, k) => d.classList.toggle('is-active', k === i));
      }
      const prev = $('[data-card-nav="-1"]', media), next = $('[data-card-nav="1"]', media);
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= n - 1;
    };
    let raf = 0;
    track.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; paint(); }); }, { passive: true });
    media._paint = paint; paint();
  };
  $$('[data-card-gallery]').forEach(setupCard);
  window.ABcards = (root = document) => $$('[data-card-gallery]', root).forEach(setupCard);

  document.addEventListener('click', (e) => {
    const nav = e.target.closest('[data-card-nav]');
    if (nav) {
      e.preventDefault(); e.stopPropagation();
      const track = $('[data-card-track]', nav.closest('[data-card-gallery]'));
      const dir = parseInt(nav.dataset.cardNav, 10) * (isRtl ? -1 : 1);
      track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
      return;
    }
    const b = e.target.closest('[data-card-swatch]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    const card = b.closest('[data-card]'); if (!card) return;
    $$('[data-card-swatch]', card).forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
    const url = b.dataset.url;
    if (url) $$('.card__title a, .card__slide', card).forEach((a) => (a.href = url));
    const media = $('[data-card-gallery]', card), track = media && $('[data-card-track]', media);
    const list = (b.dataset.imgs || '').split(';').map((x) => x.trim()).filter(Boolean);
    if (!track || !list.length) return;
    const first = $('img', track), sizes = first ? first.sizes : '50vw', alt = first ? first.alt : '';
    track.innerHTML = list.map((pair, k) => {
      const [u1, u2] = pair.split(' ');
      return `<a class="card__slide" href="${url}"${k ? ' tabindex="-1" aria-hidden="true"' : ''}><img class="card__img" src="${u1}" srcset="${u1} 450w, ${u2 || u1} 900w" sizes="${sizes}" alt="${k ? '' : alt}" loading="${k ? 'lazy' : 'eager'}" width="900" height="1125"></a>`;
    }).join('');
    track.scrollTo({ left: 0 });
    media._paint && media._paint();
  });

  /* ---------- Collection sort ---------- */
  $('[data-sort]')?.addEventListener('change', (e) => {
    const u = new URL(location.href); u.searchParams.set('sort_by', e.target.value); u.searchParams.delete('page'); location.href = u;
  });

  /* ---------- Product ---------- */
  const pdp = $('[data-product]');
  if (pdp) {
    const data = JSON.parse($('[data-product-json]').textContent);
    const form = $('[data-product-form]', pdp);
    const idInput = $('[data-variant-id]', form);
    const addBtn = $('[data-add-btn]', form);
    const addLabel = $('[data-add-label]', form);
    const priceWrap = $('[data-price-wrap]', pdp);
    const stock = $('[data-stock-note]', pdp);
    const track = $('[data-gallery-track]', pdp);
    const dotsEl = $('[data-gallery-dots]', pdp);
    const countEl = $('[data-gallery-count]', pdp);
    const sticky = $('[data-sticky-atc]');
    const fieldsets = $$('fieldset[data-option-index]', form);

    const selected = () => fieldsets.map((fs) => ($('input:checked', fs) || {}).value);
    const findVariant = (opts) => data.variants.find((v) => v.options.every((o, i) => opts[i] === undefined || o === opts[i]));

    /* gallery dots */
    const visibleItems = () => $$('.gallery__item:not([hidden])', track);
    const buildDots = () => {
      const items = visibleItems();
      dotsEl.innerHTML = '';
      if (items.length < 2) { countEl.textContent = ''; return; }
      items.forEach((it, i) => {
        const b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', `${i + 1} / ${items.length}`);
        b.addEventListener('click', () => it.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }));
        dotsEl.appendChild(b);
      });
      updateDots();
    };
    const updateDots = () => {
      const items = visibleItems(); if (!items.length) return;
      const w = track.clientWidth || 1;
      const idx = Math.min(items.length - 1, Math.round(Math.abs(track.scrollLeft) / w));
      $$('button', dotsEl).forEach((b, i) => b.setAttribute('aria-current', i === idx ? 'true' : 'false'));
      countEl.textContent = items.length > 1 ? `${idx + 1} / ${items.length}` : '';
    };
    track.addEventListener('scroll', () => requestAnimationFrame(updateDots), { passive: true });
    buildDots();

    const showGroup = (valueIndex) => {
      if (!data.grouped) return;
      const all = $$('.gallery__item', track);
      const has = all.some((it) => String(it.dataset.group) === String(valueIndex));
      all.forEach((it) => (it.hidden = has && String(it.dataset.group) !== String(valueIndex)));
      track.scrollTo({ left: 0 });
      buildDots();
    };

    const markAvailability = () => {
      const opts = selected();
      fieldsets.forEach((fs, oi) => {
        $$('input', fs).forEach((inp) => {
          const test = [...opts]; test[oi] = inp.value;
          const v = data.variants.find((x) => x.options.every((o, i) => o === test[i]));
          inp.closest('.chip, .swatch')?.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    };

    const update = (fromColor) => {
      const opts = selected();
      fieldsets.forEach((fs) => { const l = $('[data-option-label]', fs); const c = $('input:checked', fs); if (l && c) l.textContent = c.dataset.label || c.value; });
      const v = findVariant(opts);
      markAvailability();
      if (fromColor !== undefined) showGroup(fromColor);
      if (!v) {
        addBtn.disabled = true; addLabel.textContent = S.strings.unavailable;
        const bn0 = $('[data-buy-now]', form); if (bn0) bn0.disabled = true;
        return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      const bn = $('[data-buy-now]', form); if (bn) bn.disabled = !v.available;
      addLabel.textContent = v.available ? S.strings.addToCart : S.strings.soldOut;
      const sale = v.compare > v.price;
      priceWrap.innerHTML = `<span class="price${sale ? ' price--sale' : ''}"><span class="price__now">${money(v.price)}</span>${sale ? `<s>${money(v.compare)}</s>` : ''}</span>${sale && priceWrap.dataset.saveTpl ? `<span class="price__save">${priceWrap.dataset.saveTpl.replace('__A__', money(v.compare - v.price).replace(/\.00(?!\d)/, ''))}</span>` : ''}`;
      if (stock) {
        const low = v.available && v.qty !== null && v.qty > 0 && v.qty <= data.lowStock;
        stock.hidden = !low;
        if (low) stock.textContent = stock.textContent.replace(/\d+/, v.qty);
      }
      if (sticky) {
        $('[data-sticky-variant]', sticky).textContent = `${fieldsets.map((fs) => { const c = $('input:checked', fs); return c ? (c.dataset.label || c.value) : ''; }).join(' / ')} · `;
        $('[data-sticky-price]', sticky).textContent = money(v.price);
        $('[data-sticky-add]', sticky).disabled = !v.available;
      }
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
    };

    const gallerySw = $$('[data-gallery-swatch]', pdp);
    const swBar = $('.gallery__swatches', pdp);
    const colorFs = fieldsets.find((fs) => fs.dataset.optionIndex === String(data.colorIndex));
    if (swBar && colorFs && 'IntersectionObserver' in window) {
      // Hide the on-photo picker as soon as the full colour options scroll into view (or the photo scrolls away)
      new IntersectionObserver(([en]) => {
        const below = en.boundingClientRect.top > window.innerHeight;
        swBar.classList.toggle('is-hidden', en.isIntersecting || !below);
      }, { threshold: 0 }).observe(colorFs);
    }
    const gallery = $('[data-gallery]', pdp);
    const syncGallerySw = (idx) => gallerySw.forEach((b) => b.setAttribute('aria-pressed', b.dataset.gallerySwatch === String(idx) ? 'true' : 'false'));
    const markGallerySw = () => {
      const cf = fieldsets.find((fs) => fs.dataset.optionIndex === String(data.colorIndex)); if (!cf) return;
      $$('input', cf).forEach((inp) => {
        const b = gallerySw.find((x) => x.dataset.gallerySwatch === inp.dataset.valueIndex);
        b?.classList.toggle('is-out', !!inp.closest('.swatch')?.classList.contains('is-unavailable'));
      });
    };
    gallerySw.forEach((b) => b.addEventListener('click', () => {
      const cf = fieldsets.find((fs) => fs.dataset.optionIndex === String(data.colorIndex));
      const inp = cf && $(`input[data-value-index="${b.dataset.gallerySwatch}"]`, cf);
      if (!inp) return;
      inp.checked = true; fromGallery = true;
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    let fromGallery = false;
    form.addEventListener('change', (e) => {
      const inp = e.target.closest('input[type=radio]'); if (!inp) return;
      const isColor = inp.closest('fieldset')?.dataset.optionIndex === String(data.colorIndex);
      update(isColor ? inp.dataset.valueIndex : undefined);
      if (isColor) {
        syncGallerySw(inp.dataset.valueIndex);
        // Picked from the options below on mobile: bring the photos back into view
        if (!fromGallery && window.innerWidth < 990 && gallery) {
          const r = gallery.getBoundingClientRect();
          if (r.bottom < window.innerHeight * 0.35) {
            const hh = document.querySelector('[data-header]')?.offsetHeight || 0;
            window.scrollTo({ top: window.scrollY + r.top - hh - 8, behavior: 'smooth' });
          }
        }
        fromGallery = false;
      }
      markGallerySw();
    });
    markAvailability();
    markGallerySw();

    /* sticky add-to-cart (mobile) */
    if (sticky && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        $('[data-sticky-add]', sticky).tabIndex = show ? 0 : -1;
      });
      io.observe(addBtn);
      $('[data-sticky-add]', sticky).addEventListener('click', () => {
        const needsChoice = fieldsets.some((fs) => !$('input:checked', fs));
        if (needsChoice) { form.scrollIntoView({ behavior: 'smooth', block: 'center' }); toast(S.strings.chooseSize); return; }
        form.requestSubmit ? form.requestSubmit(addBtn) : addBtn.click();
      });
    }
  }

  /* ---------- Article reading progress ---------- */
  const art = $('[data-article-body]'), bar = $('[data-read-progress]');
  if (art && bar) {
    const done = $('[data-article-done]'), header = $('[data-header]');
    let raf = 0;
    const tick = () => {
      raf = 0;
      const top = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      bar.style.top = `${top}px`;
      const r = art.getBoundingClientRect(), vh = window.innerHeight;
      const total = r.height - vh * 0.6;
      const p = total <= 0 ? (r.top < vh ? 1 : 0) : Math.min(1, Math.max(0, (top + 20 - r.top) / total));
      bar.firstElementChild.style.setProperty('--read', p.toFixed(4));
      const fin = p >= 0.995;
      bar.classList.toggle('is-done', fin);
      done?.classList.toggle('is-done', fin);
    };
    tick(); window.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(tick); }, { passive: true }); window.addEventListener('resize', tick);
  }

  /* ---------- First-order pop-up ---------- */
  const promo = $('[data-promo]');
  if (promo) {
    const KEY = 'ab_promo', store = { get: () => { try { return localStorage.getItem(KEY); } catch (e) { return null; } }, set: (v) => { try { localStorage.setItem(KEY, v); } catch (e) {} } };
    const success = $('[data-promo-success]', promo);
    const state = store.get();
    const now = Date.now();
    const open = () => {
      if (promo.classList.contains('is-open') || document.querySelector('.drawer.is-open')) return;
      promo.classList.add('is-open'); promo.setAttribute('aria-hidden', 'false'); document.body.classList.add('no-scroll');
      setTimeout(() => ($('input[type=email]', promo) || $('.promo__close', promo))?.focus({ preventScroll: true }), 350);
    };
    const close = (snooze = true) => {
      promo.classList.remove('is-open'); promo.setAttribute('aria-hidden', 'true'); document.body.classList.remove('no-scroll');
      if (snooze && !success) store.set(`closed:${Date.now()}`);
    };
    promo.addEventListener('click', (e) => { if (e.target.closest('[data-promo-close]')) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && promo.classList.contains('is-open')) close(); });
    $('[data-promo-copy]', promo)?.addEventListener('click', async (e) => {
      try { await navigator.clipboard.writeText(promo.dataset.code); e.currentTarget.textContent = promo.dataset.copied || '✓'; } catch (err) {}
    });
    $('#promo-form', promo)?.addEventListener('submit', () => store.set('joined'));
    if (success) { store.set('joined'); open(); }
    else {
      const closedAt = state && state.startsWith('closed:') ? parseInt(state.split(':')[1], 10) : 0;
      const snoozed = closedAt && now - closedAt < 14 * 864e5;
      if (state !== 'joined' && !snoozed) {
        let armed = false;
        const arm = () => { if (armed) return; armed = true; open(); cleanup(); };
        const t = setTimeout(arm, (parseInt(promo.dataset.delay, 10) || 12) * 1000);
        const pct = (parseInt(promo.dataset.scroll, 10) || 40) / 100;
        const onScroll = () => { const max = document.documentElement.scrollHeight - innerHeight; if (max > 0 && scrollY / max >= pct) arm(); };
        const onLeave = (e) => { if (e.clientY <= 0 && !e.relatedTarget) arm(); };
        const cleanup = () => { clearTimeout(t); removeEventListener('scroll', onScroll); document.removeEventListener('mouseout', onLeave); };
        addEventListener('scroll', onScroll, { passive: true });
        if (matchMedia('(hover: hover)').matches) setTimeout(() => document.addEventListener('mouseout', onLeave), 4000);
      }
    }
  }

  /* ---------- Care guide carousel (arrows + gentle autoplay) ---------- */
  $$('[data-care]').forEach((sec) => {
    const track = $('[data-care-track]', sec); if (!track) return;
    const step = () => { const c = $('.care__card', track); return c ? c.getBoundingClientRect().width + 12 : track.clientWidth; };
    const dirSign = document.documentElement.dir === 'rtl' ? -1 : 1;
    const go = (d) => {
      const max = track.scrollWidth - track.clientWidth, cur = Math.abs(track.scrollLeft);
      if (d > 0 && cur >= max - 4) track.scrollTo({ left: 0 });
      else track.scrollBy({ left: d * dirSign * step() });
    };
    $$('[data-care-nav]', sec).forEach((b) => b.addEventListener('click', () => go(parseInt(b.dataset.careNav, 10))));
    const secs = parseInt(track.dataset.autoplay || '0', 10);
    if (secs && true) {
      let paused = false, visible = false;
      ['mouseenter', 'touchstart', 'focusin'].forEach((ev) => sec.addEventListener(ev, () => (paused = true), { passive: true }));
      ['mouseleave', 'focusout'].forEach((ev) => sec.addEventListener(ev, () => (paused = false)));
      sec.addEventListener('touchend', () => setTimeout(() => (paused = false), 3000), { passive: true });
      if ('IntersectionObserver' in window) new IntersectionObserver(([en]) => (visible = en.isIntersecting)).observe(sec);
      setInterval(() => { if (!paused && visible) go(1); }, secs * 1000);
    }
  });

  /* ---------- Category strip: pause on hover / touch ---------- */
  $$('[data-arch-marquee]').forEach((m) => {
    const pause = () => m.classList.add('is-paused'), play = () => m.classList.remove('is-paused');
    m.addEventListener('mouseenter', pause); m.addEventListener('mouseleave', play);
    m.addEventListener('touchstart', pause, { passive: true });
    m.addEventListener('touchend', () => setTimeout(play, 2500), { passive: true });
    m.addEventListener('focusin', pause); m.addEventListener('focusout', play);
  });

  /* ---------- Hero parallax (one transform per frame, only while visible) ---------- */
  if (true) {
    $$('[data-hero]').forEach((hero) => {
      const media = $('.hero__media', hero); if (!media) return;
      let visible = true, raf = 0;
      const tick = () => { raf = 0; if (!visible) return; const r = hero.getBoundingClientRect(); media.style.setProperty('--hero-y', `${Math.max(0, -r.top) * 0.25}px`); };
      if ('IntersectionObserver' in window) new IntersectionObserver(([en]) => { visible = en.isIntersecting; }).observe(hero);
      window.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(tick); }, { passive: true });
    });
  }

  /* ---------- A&B in Motion ---------- */
  $$('[data-motion]').forEach((sec) => {
    const vid = $('video', sec);
    const reduce = false;
    if (!reduce && !sec.classList.contains('motion--page')) {
      let ticking = false;
      const onScroll = () => {
        if (ticking) return; ticking = true;
        requestAnimationFrame(() => {
          const r = sec.getBoundingClientRect(), vh = window.innerHeight;
          // 0 when the section top enters the bottom of the screen, 1 when it reaches ~20% from the top
          const p = Math.min(1, Math.max(0, (vh - r.top) / (vh * 0.8)));
          sec.style.setProperty('--p', p.toFixed(3));
          ticking = false;
        });
      };
      onScroll(); window.addEventListener('scroll', onScroll, { passive: true }); window.addEventListener('resize', onScroll);
    } else sec.style.setProperty('--p', 1);
    if (!vid) return;
    vid.muted = true; vid.playsInline = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const paused = $('[data-motion-play]', sec)?.getAttribute('aria-pressed') === 'true';
        if (en.isIntersecting && !paused) vid.play().catch(() => {}); else vid.pause();
      }, { threshold: 0.25 }).observe(sec);
    }
    $('[data-motion-play]', sec)?.addEventListener('click', (e) => {
      const b = e.currentTarget, pause = b.getAttribute('aria-pressed') !== 'true';
      b.setAttribute('aria-pressed', pause ? 'true' : 'false');
      pause ? vid.pause() : vid.play().catch(() => {});
    });
    $('[data-motion-sound]', sec)?.addEventListener('click', (e) => {
      const b = e.currentTarget; vid.muted = !vid.muted;
      b.setAttribute('aria-pressed', vid.muted ? 'false' : 'true');
      if (!vid.muted) vid.play().catch(() => {});
    });
  });

  /* ---------- Recommendations ---------- */
  const recs = $('[data-recs]');
  if (recs && !recs.children.length) {
    fetch(recs.dataset.url).then((r) => r.text()).then((t) => {
      const el = new DOMParser().parseFromString(t, 'text/html').querySelector('[data-recs]');
      if (el && el.innerHTML.trim()) { recs.innerHTML = el.innerHTML; window.ABwatch?.(recs); window.ABcards?.(recs); } else recs.remove();
    }).catch(() => recs.remove());
  }
})();
